module.exports = __webpack_public_path__ + "img/typeother.8e51933f.png";